import NetworkService from "../config/interceptor/interceptor";

export const getPagedUsersService = async (
  page = 0,
  size = 20,
  filters?: { search?: string; role?: string; isEnabled?: boolean; educationLevel?: string }
) => {
  const params = new URLSearchParams({
    page: String(page),
    size: String(size),
  });
  if (filters?.search) {
    params.append("search", filters.search.trim());
  }
  if (filters?.role) {
    params.append("role", filters.role);
  }
  if (typeof filters?.isEnabled === "boolean") {
    params.append("isEnabled", String(filters.isEnabled));
  }
  if (filters?.educationLevel) {
    params.append("educationLevel", filters.educationLevel);
  }

  const response = await NetworkService.getInstance().sendHttpRequest({
    url: `users/paged?${params.toString()}`,
    method: "GET",
    withLoader: false,
    withFailureLogs: true,
  });
  return response.data;
};

export const updateUserService = async (id: number | string, userData: any) => {
  const response = await NetworkService.getInstance().sendHttpRequest({
    url: `users/${id}`,
    method: "PUT",
    data: userData,
    withLoader: true,
    withFailureLogs: true,
  });
  return response.data;
};

export const deleteUserService = async (id: number | string) => {
  const response = await NetworkService.getInstance().sendHttpRequest({
    url: `users/${id}`,
    method: "DELETE",
    withLoader: true,
    withFailureLogs: true,
  });
  return response.data;
};

const UserService = {
  getPagedUsersService,
  updateUserService,
  deleteUserService,
};

export default UserService;
